var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons_Contact_ic-contact-phone-2",
    "data-name": "Icons / Contact / ic-contact-phone-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 30,
    height: 30,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-contact-phone-2",
    transform: "translate(2.619 4.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M20.275,22.45H7.5a2.5,2.5,0,0,1-2.337-3.388l2.412-6.425A2.5,2.5,0,0,1,9.9,11h7.963a2.5,2.5,0,0,1,2.35,1.625l2.4,6.425a2.5,2.5,0,0,1-2.338,3.4Z",
    transform: "translate(-1.35 -2.028)",
    fill: "none",
    stroke: "#e2e301",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(10.038 12.209)",
    fill: "none",
    stroke: "#e2e301",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M2.08,6.207V9.182a2.5,2.5,0,0,0,2.5,2.5H5.73a2.5,2.5,0,0,0,2.5-2.5V7.594h0a32.05,32.05,0,0,1,12.5,0h0V9.182a2.5,2.5,0,0,0,2.5,2.5h1.112a2.5,2.5,0,0,0,2.5-2.5V6.207a1.25,1.25,0,0,0-1.012-1.25h0a57.725,57.725,0,0,0-22.775,0h0A1.25,1.25,0,0,0,2.08,6.207Z",
    transform: "translate(-2.08 -3.823)",
    fill: "none",
    stroke: "#e2e301",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.b0e9e0e54848e9b5c5f76a41f4fad4bd.svg";
export { ForwardRef as ReactComponent };